import React from 'react';
// GameGuide imports
import AssetsManager from '../../../../Game/Base/AssetManager';
import LibraryManager from '../../../../Game/Base/Library/LibraryManager';

function PlayerPreview({ game }) {
    const {
        player: { hat, texture, textureHue }
    } = game;

    // Get texture and overlay html elements
    const textureUrl = LibraryManager.textures.get(texture).get().baseTexture.source.src;
    const overlayUrl = AssetsManager.get('img.player_overlay').baseTexture.source.src;

    // Get hat information
    const hatEntry = LibraryManager.hats.get(hat);
    const hatPos = hatEntry.posSide;
    const hatImage = hatEntry.getSide();
    const hatUrl = hatImage.baseTexture.source.src;
    const hatOriginalSize = hatImage.orig;

    const playerOriginalSize = {width: 64, height: 64 };

    const hatSizeInPercentage = {
        width: (hatOriginalSize.width / playerOriginalSize.width) * 100.0,
        height: (hatOriginalSize.height / playerOriginalSize.height) * 100.0
    };

    const absoluteHatPos = {
        left: (100.0 - hatSizeInPercentage.width) / 2.0,
        top: -(hatSizeInPercentage.height / 2.0)
    }

    const absoluteHatPosCorrection = {
        left: (hatPos.x / playerOriginalSize.width) * 100.0,
        top: (hatPos.y / playerOriginalSize.height) * 100.0
    };

    absoluteHatPos.top -= absoluteHatPosCorrection.top;
    absoluteHatPos.left += absoluteHatPosCorrection.left;    

    return (
        <div className="player-visual">
            <img
                className="player-hat"
                src={hatUrl}
                alt="Speler hoed"
                style={{
                    width: `${hatSizeInPercentage.width}%`,
                    top: `${absoluteHatPos.top}%`,
                    left: `${absoluteHatPos.left}%`
                }}
            />
            <img
                className="player-body-overlay"
                src={overlayUrl}
                alt="Speler lichaam overlay"
            />
            <img
                className="player-body"
                src={textureUrl}
                alt="Speler lichaam"
                style={{
                    filter: `hue-rotate(${textureHue}deg)`
                }}
            />
        </div>
    );
}

export default PlayerPreview;